import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { getSize, getRadius } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { CloseButton } from "./auth-service-tools280.js";
import { usePillsInputContext } from "./auth-service-tools384.js";
import { usePillGroupContext } from "./auth-service-tools385.js";
import { PillGroup } from "./auth-service-tools386.js";
import classes from "./auth-service-tools387.js";
const defaultProps = {
  variant: "default"
};
const varsResolver = createVarsResolver((_, _ref, _ref2) => {
  let {
    radius
  } = _ref;
  let {
    size
  } = _ref2;
  return {
    root: {
      "--pill-fz": getSize(size, "pill-fz"),
      "--pill-height": getSize(size, "pill-height"),
      "--pill-radius": radius === void 0 ? void 0 : getRadius(radius)
    }
  };
});
const Pill = factory((_props, ref) => {
  const props = useProps("Pill", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    variant,
    children,
    withRemoveButton,
    onRemove,
    removeButtonProps,
    radius,
    size,
    disabled,
    mod,
    ...others
  } = props;
  const ctx = usePillGroupContext();
  const pillsInputCtx = usePillsInputContext();

  const _size = size || (ctx == null ? void 0 : ctx.size) || void 0;

  const _variant = (pillsInputCtx == null ? void 0 : pillsInputCtx.variant) === "filled" ? "contrast" : variant || "default";

  const getStyles = useStyles({
    name: "Pill",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver,
    stylesCtx: {
      size: _size
    }
  });
  return /* @__PURE__ */jsxRuntimeExports.jsxs(Box, {
    component: "span",
    ref,
    variant: _variant,
    size: _size,
    ...getStyles("root", {
      variant: _variant
    }),
    mod: [{
      "with-remove": withRemoveButton && !disabled,
      disabled: disabled || (ctx == null ? void 0 : ctx.disabled)
    }, mod],
    ...others,
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("span", { ...getStyles("label"),
      children
    }), withRemoveButton && /* @__PURE__ */jsxRuntimeExports.jsx(CloseButton, {
      variant: "transparent",
      radius,
      tabIndex: -1,
      "aria-hidden": true,
      unstyled,
      ...removeButtonProps,
      ...getStyles("remove", {
        className: removeButtonProps == null ? void 0 : removeButtonProps.className,
        style: removeButtonProps == null ? void 0 : removeButtonProps.style
      }),
      onMouseDown: event => {
        var _a;

        event.preventDefault();
        event.stopPropagation();
        (_a = removeButtonProps == null ? void 0 : removeButtonProps.onMouseDown) == null ? void 0 : _a.call(removeButtonProps, event);
      },
      onClick: event => {
        var _a;

        event.stopPropagation();
        onRemove == null ? void 0 : onRemove();
        (_a = removeButtonProps == null ? void 0 : removeButtonProps.onClick) == null ? void 0 : _a.call(removeButtonProps, event);
      }
    })]
  });
});
Pill.classes = classes;
Pill.displayName = "@mantine/core/Pill";
Pill.Group = PillGroup;
export { Pill };